import { Skeleton } from "@mui/material";
import { BlockCard, MetricTileSkeleton } from "../primitives";
import styles from "./style.module.scss";

interface HeadlineFiguresBlockSkeletonProps {
  count?: number;
  withDefinitions?: boolean;
  /** Band rows rendered inside the status-split placeholder. */
  bandCount?: number;
  className?: string;
}

/** Mirrors the split tile plus three figure tiles at their real proportions. */
function HeadlineFiguresBlockSkeleton({
  count = 3,
  withDefinitions,
  bandCount = 3,
  className,
}: HeadlineFiguresBlockSkeletonProps) {
  return (
    <BlockCard
      title={<Skeleton variant="text" width={165} height={20} />}
      compactTitle
      className={className}
    >
      <div className={styles.grid}>
        <div className={`${styles.tile} ${styles.splitTile}`}>
          <div className={styles.splitHead}>
            <Skeleton variant="text" width="55%" height={18} />
            <Skeleton
              variant="rounded"
              width={32}
              height={32}
              sx={{ borderRadius: "8px", flexShrink: 0 }}
            />
          </div>
          <div className={styles.bandList}>
            {Array.from({ length: bandCount }).map((_, index) => (
              <div key={index} className={styles.bandRow}>
                <div className={styles.bandLabel}>
                  <Skeleton variant="circular" width={10} height={10} />
                  <Skeleton variant="text" width={72} height={18} />
                </div>
                <Skeleton variant="text" width={26} height={22} />
                <Skeleton
                  variant="rounded"
                  width={38}
                  height={18}
                  sx={{ borderRadius: "10px" }}
                />
                <Skeleton
                  variant="rounded"
                  width={58}
                  height={24}
                  sx={{ borderRadius: "8px" }}
                />
              </div>
            ))}
          </div>
          {withDefinitions && (
            <div className={styles.definition}>
              <Skeleton variant="text" width="100%" height={14} />
              <Skeleton variant="text" width="70%" height={14} />
            </div>
          )}
        </div>

        {Array.from({ length: count }).map((_, index) => (
          <MetricTileSkeleton
            key={index}
            emphasis
            withDefinition={withDefinitions}
          >
            {/* Only the first and last figure carry a ring in the design. */}
            {index !== 1 && (
              <div className={styles.ring}>
                <Skeleton variant="circular" width={76} height={76} />
                <div className={styles.ringLegend}>
                  <Skeleton variant="text" width={92} height={16} />
                  <Skeleton variant="text" width={78} height={16} />
                </div>
              </div>
            )}
          </MetricTileSkeleton>
        ))}
      </div>
    </BlockCard>
  );
}

export default HeadlineFiguresBlockSkeleton;
